import { initRedesignCardSliders } from '../collection/product-card-slider'

export default el => {
  initRedesignCardSliders(el)
}
